module.exports = "<div class=\"pointer-graph\">\n    <div *ngFor=\"let item of graphCount\">\n        <span [style.width.%]=\"item.width\" [class.green]=\"currentColor==='green'\" [class.yellow]=\"currentColor==='yellow'\" [class.red]=\"currentColor==='red'\"></span>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/components/pointer-graph/pointer-graph.component.html
// module id = ./src/app/view/components/pointer-graph/pointer-graph.component.html
// module chunks = main